import layout from './ChangePasswordView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import ChangePasswordViewModel from '@/ViewModels/Views/ChangePasswordViewModel';
import Utilities from '@/Utility/Utilities';

export default class ChangePasswordView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: ChangePasswordViewModel, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement>    {
        if (this.view != null) {
            return this.view;
        }

        this.viewModel.window.onActivate = () => {
            // Wenn Passwörter gespeichert sind, füllen Browser hier das Passwort aus
            if (this.viewModel.oldPassword.value() === '') {
                window.setTimeout(() => {
                    this.viewModel.oldPassword.value('');
                }, 100);

                Utilities.focusFirstFocusableElement(this.view.find('input'));
            }
        };

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('ChangePasswordView', ChangePasswordView, 'RADPresentation.HTMLClient.DefaultViewExtensions');